import { render, staticRenderFns } from "./dataShareModal.vue?vue&type=template&id=6a753f53&scoped=true"
import script from "./dataShareModal.vue?vue&type=script&lang=js"
export * from "./dataShareModal.vue?vue&type=script&lang=js"
import style0 from "./dataShareModal.vue?vue&type=style&index=0&id=6a753f53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a753f53",
  null
  
)

export default component.exports